import { useContext } from "react";
import useSWR from "swr";
import { http } from "~/services/http";
import { PreviewModeContext, isLiveMode } from "~/context/PreviewModeContext";

export const useFetchStudyFile = (fileGuid, onSuccess) => {
  const { mode } = useContext(PreviewModeContext);
  const isPreviewOrPrint = !isLiveMode(mode);

  // In preview/print, we MUST NOT hit the API. Pass `null` as the SWR key so
  // the fetcher never fires; return the same shape live callers expect.
  const swrKey = !isPreviewOrPrint && fileGuid ? `/api/studyfile/${fileGuid}` : null;

  const {
    data: studyFile,
    error,
    isLoading,
  } = useSWR(swrKey, http.get, {
    revalidateOnFocus: false,
    onSuccess,
  });

  if (isPreviewOrPrint) {
    return { studyFile: null, isLoading: false, error: null };
  }

  return { studyFile, isLoading, error };
};
